import { TableCellHeaderProps } from 'components/TableItems/interfaces';

export default [
  {
    key: 'partner_name',
    i18n: 'PARTNER_KEY',
    order: true,
  },
  {
    key: 'environment_name',
    i18n: 'ENVIRONMENT_KEY',
    order: true,
  },
  {
    key: 'environment_type',
    i18n: 'BEHAVIOR_KEY',
    order: true,
    centerTitle: true,
  },
  {
    key: 'advisor_type',
    i18n: 'TYPE_KEY',
    order: true,
    centerTitle: true,
  },
  {
    key: 'created_at',
    i18n: 'CREATED_AT_KEY',
    style: { width: '130px' },
    order: true,
    centerTitle: true,
  },
  {
    key: 'estimated_monthly_cost_savings',
    i18n: 'ADVISOR_PAGE.ESTIMATED_COST_SAVINGS_KEY',
    order: true,
  },
  {
    key: 'impact',
    i18n: 'RISK_KEY',
    order: true,
    centerTitle: true,
  },
  {
    key: 'status',
    i18n: 'STATUS_KEY',
    order: true,
    centerTitle: true,
  },
] as TableCellHeaderProps[];
